import { useState } from 'react';

import { PaginationProps } from './Pagination';

type Props = Pick<PaginationProps, 'rowsPerPage'> & { itemsCount: number };

export const usePages = ({ rowsPerPage, itemsCount }: Props) => {
	const [currentPage, onPageChange] = useState(0);

	const numberOfPages = Math.ceil(itemsCount / rowsPerPage);

	return { currentPage, numberOfPages, onPageChange };
};
